export const OFFER_STATUS_ENUM = {
  IN_PROGRESS: 1,
  CONFIRMED: 2,
  CANCELED: 3
}
